import { useState } from "react";
import { DotsThreeVertical, X } from "@phosphor-icons/react";

export function Breadcrumb({ breadcrumb, onHome, onNav }) {
  return (
    <div className="flex items-center gap-1 text-sm mb-4 flex-wrap" data-testid="breadcrumb">
      <button onClick={onHome} className="px-2 py-1 hover:bg-black/5 rounded inline-flex items-center gap-1.5 text-black/75 hover:text-black">
        Drive
      </button>
      {breadcrumb.map((b, i) => {
        const last = i === breadcrumb.length - 1;
        return (
          <span key={b.id} className="inline-flex items-center gap-1">
            <span className="text-black/40 px-1">/</span>
            <button onClick={() => onNav(b.id)} className={`px-2 py-1 hover:bg-black/5 rounded ${last ? "font-medium text-black" : "text-black/65"}`}>
              {b.name}
            </button>
          </span>
        );
      })}
    </div>
  );
}

export function RowMenu({ items, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }} className="p-1.5 rounded hover:bg-black/10 text-black/55 hover:text-black" data-testid={testid}>
        <DotsThreeVertical size={16} weight="bold"/>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)}/>
          <div className="absolute right-0 top-full mt-1 bg-white border border-black/15 rounded-md shadow-lg py-1 z-20 min-w-[180px]">
            {items.map((it, i) => (
              <button key={i} onClick={() => { it.onClick(); setOpen(false); }}
                      data-testid={`menu-${it.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}
                      className={`w-full px-3 py-2 text-left flex items-center gap-3 text-sm hover:bg-black/5 ${it.danger ? "text-[#DC2626]" : ""}`}>
                {it.icon} <span>{it.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export function Modal({ title, children, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4" onClick={onClose}>
      <div className="bg-white rounded-md w-full max-w-md shadow-xl" onClick={(e) => e.stopPropagation()} data-testid="modal">
        <div className="px-5 py-3 border-b border-black/10 flex items-center justify-between">
          <div className="font-bold">{title}</div>
          <button onClick={onClose} className="text-black/55 hover:text-[#FF3366]" data-testid="modal-close"><X size={18}/></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function MenuItem({ icon, label, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid} className="w-full px-3 py-2 hover:bg-black/5 flex items-center gap-3 text-sm">
      {icon} <span>{label}</span>
    </button>
  );
}
